import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { useMutation } from '@tanstack/react-query';
import { Loader2 } from 'lucide-react';
import { useAuthContext } from '@/contexts/AuthContext';
import { iniciarConversaApp } from '@/services/chat-app.service';
import { sanitizeSupabaseError } from '@/lib/errorHandler';

/** Botão "Pedir orçamento". Anon → signup de cliente; cliente logado → inicia conversa app;
 *  user de empresa logado → "em breve" (não é cliente). */
export function ContactoCTA({ orgId }: { orgId: string }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, isConsumer } = useAuthContext();

  const iniciar = useMutation({
    mutationFn: () => iniciarConversaApp(orgId),
    onSuccess: (clienteId) => navigate(`/app/conversas/${clienteId}`),
    onError: (e) => toast.error(sanitizeSupabaseError(e)),
  });

  const onClick = () => {
    if (!user) { navigate('/auth?tab=signup'); return; }
    if (!isConsumer) { toast.message(t('marketplace.contact.soon')); return; }
    iniciar.mutate();
  };

  return (
    <button type="button" className="ow-btn ow-btn--primary ow-btn--block" onClick={onClick} disabled={iniciar.isPending}>
      {iniciar.isPending && <Loader2 className="h-4 w-4 animate-spin" />}
      {t('marketplace.contact.cta')}
    </button>
  );
}
